<h3 mat-dialog-header class="text-uppercase" [innerHTML]="data.header"></h3>
<section mat-dialog-content>
    <p> {{ data.message }} <strong *ngIf="showTimer"> {{ timer }} </strong></p>
    <div class="form-group" *ngIf="data.requireConfirmText">
        <label for="confirmTextInput" class="col-sm-4 col-form-label">
            Write '{{ confirmWord }}' to proceed
            <span class="requiredlbl">*</span>
        </label>
        <input id="confirmTextInput" type="text" class="form-control" [(ngModel)]="confirmText" autocomplete="off" />
    </div>
</section>
<section mat-dialog-actions>
    <div fxFlex="100">
        <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="8px">
            <button *ngIf="!data.noCancel" fxFlex="40" mat-raised-button mat-dialog-close cdkFocusInitial
                color="ascent">DISAGREE</button>
            <button fxFlex="40" mat-raised-button [mat-dialog-close]="true" color="primary"
                [disabled]="isConfirmDisabled">AGREE</button>
        </div>
    </div>
</section>